import { useLayoutEffect, useState } from "react";
import omegaStyle from "./omega.module.css";

import Event from "./event/list";
import EventMaker from "./form/EventMaker";
import Menu from "./menu/menu";

import Notice from "manager/cmath/notice/notice";
import { useLocation } from "react-router";
import Stat from "./stat/Stat";

export default function Omega() {
	const [branchInfo, Set_branchInfo] = useState({
		id: "0000",
		name: "관리",
	});

	const [selectTab, Set_selectTab] = useState(0);

	const [screenWidth, Set_screenWidth] = useState(window.innerWidth);
	const [screenHeight, Set_screenHeight] = useState(window.innerHeight);

	window.EventManager = {
		branchInfo: branchInfo,
	};

	useLayoutEffect(() => {
		document.body.classList.add(omegaStyle["body"]);

		window.addEventListener("contextmenu", function (e) {
			e.preventDefault();
		});

		window.addEventListener("resize", function () {
			Set_screenWidth(window.innerWidth);
			Set_screenHeight(window.innerHeight);
		});
	}, []);

	return (
		<div
			className={omegaStyle["omegaWrap"]}
			style={{
				width: screenWidth,
				height: screenHeight,
			}}
		>
			<div className={omegaStyle["leftMenu"]}>
				<Menu selectTab={selectTab} Set_selectTab={Set_selectTab}></Menu>
			</div>

			<div
				className={omegaStyle["contentWrap"]}
				style={{
					display: selectTab === 0 ? "block" : "none",
				}}
			>
				<EventMaker></EventMaker>
			</div>

			<div
				className={omegaStyle["contentWrap"]}
				style={{
					display: selectTab === 1 ? "block" : "none",
				}}
			>
				<div className={omegaStyle["contentTop"]}>
					<Notice></Notice>
				</div>
			</div>

			<div
				className={omegaStyle["contentWrap"]}
				style={{
					display: selectTab === 2 ? "block" : "none",
				}}
			>
				<Stat />
			</div>
		</div>
	);
}
